import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// Load locale messages from JSON files in src/locales
const loadLocaleMessages = () => {
  const messages = {};
  const context = require.context(
    "./locales",
    false,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  context.keys().forEach((key) => {
    const locale = key.replace("./", "").replace(".json", "");
    const localeModule = context(key);
    const localeMessages = localeModule.default || localeModule;
    messages[locale] = { ...localeMessages };
  });

  return messages;
};


// {{ $t('menu.transactions') }}

// Create i18n instance
const i18n = new VueI18n({
  locale: "en", // default locale
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});

export default i18n;
